import {
  Token,
  TokenAttribute,
  ALLOWED_TAGS,
} from '@cigna/resource-content/contracts';

const CONFIG_MAP: { [tag: string]: string[] } = ALLOWED_TAGS.reduce(
  (m: { [tag: string]: string[] }, r) => {
    r.tags.forEach((t) => {
      m[t] = r.attributes.map((s) => s.name);
    });
    return m;
  },
  {},
);

export interface VerboseToken {
  type: Token[0];
  content: Token[1];
  attr: { [key: string]: string };
}

export function mapToken(
  token: Token,
  interpolateFn?: (raw: string) => string | undefined,
): VerboseToken {
  if (typeof token === 'string') {
    return { type: 'text', content: token, attr: {} };
  }

  const attributes: { [key: string]: string } = {};
  const knownAttributes = CONFIG_MAP[token[0]] || [];
  const interpolate = (raw: string) => interpolateFn?.(raw) ?? raw;

  (token.slice(2) as TokenAttribute[]).forEach((part, i) => {
    if (!part) {
      return;
    }

    if (knownAttributes[i]) {
      attributes[knownAttributes[i]] = interpolate(part as string);
    } else {
      attributes[interpolate(part[0])] = interpolate(part[1]);
    }
  });

  return { type: token[0], content: token[1], attr: attributes };
}
